import { apiRequest } from "../util/apiUtils";

export const applicationList = async (params) => {
  try {
    const res = await apiRequest("get", `application/backend/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const applicationAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `application/backend/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      }
      // "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const applicationAddEditUser = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `application/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const applicationDetails = async (payload) => {
  try {
    const res = await apiRequest("get", `/application/backend/detail/${payload?.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const applicationDetailsUser = async (payload) => {
  try {
    const res = await apiRequest("get", `/application/detail/${payload?.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const applicationStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `application/backend/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const applicationDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `application/backend/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
